import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Button } from '../Button';
export const PillButton = styled(({ variant = 'black-on-gray', size = 'small', borderless = true, ...props }) => {
    return _jsx(Button, { variant: variant, size: size, borderless: borderless, ...props });
}) `
  border-radius: ${o => o.theme.spacing(5)};
  padding: ${o => o.theme.spacing(0, 2)};
`;
//# sourceMappingURL=index.js.map